













































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import util from '@/utils/util';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import ReservedDetail from './reservedDetail/index.vue';

const reservedDetail = util.mountVueComponent(ReservedDetail);
@Component({
  components: {
    BulkSearchModal,
  },
})
export default class ProductionBatchInventoryPage extends Vue {
  /** 是否精确查找 */
  private isAccurate: boolean = true;
  /**  */
  private codeField: string = 'product_sku';
  /** 列表数据 */
  private dataList: TypeBatchInventory.ListItem[] = [];
  /** 表格列属性 */
  private columns: TypeBase.TableColumn[] = [];
  /** 请求状态 */
  private loadingStatus: boolean = false;
  /** 列表勾选 */
  private rowSelection: TypeBase.RowSelection = {};
  /** 仓库列表 */
  private warehouseList: TypeCommon.AllWarehouseListItem[] = [];
  /** 搜索项 */
  private searchData: TypeBatchInventory.SearchData = this.initSearchData();
  /** 搜索项 */
  private searchParam: TypeBatchInventory.SearchData = this.initSearchData();
  /** 页码总数 */
  private total: number = 0;
  // 可售总数
  protected sellable_total: number = 0;
  /** 选中的sku列表 */
  private selectedIdList: string[] = [];
  /** 多选文本框 */
  private docValue: string = '';
  /** 库存类型 */
  @enumData('Inventory/InventoryTypeUiEnum')
  private inventoryTypeEnum: TypeBase.EnumListItem[] = [];
  /** 商品品质枚举 */
  @enumData('Outbound/ProductQualityEnum')
  protected orderProductQualityEnum!: TypeBase.EnumListItem[];
  /** 获取选中项列表 */
  private get selectedList(): TypeBatchInventory.ListItem[] {
    return this.dataList.filter((item: TypeBatchInventory.ListItem) => {
      return this.selectedIdList.indexOf(item.id) > -1;
    });
  }
  protected product_quanlity = 0;
  @Watch('searchData.inventory_type', { immediate: true })
  private onSearchDataQtyTypeChange(val: number): void {
    if (this.checkShowProductQuality(val)) {
      this.searchData.product_quanlity = this.$enum.product.ProductQualityEnum.GOOD;
    } else {
      this.searchData.product_quanlity = undefined;
    }
  }
  /**
   * 初始化查询参数
   */
  @userPrefPageSize('batchInventoryProductionBatchInventoryList')
  private initSearchData(): TypeBatchInventory.SearchData {
    return {
      /** 区域仓代码  */
      warehouse_code: undefined,
      /** 商品sku（精确查询） */
      product_sku: '',
      /** 商品中文名称（模糊搜索） */
      product_sku_like: '',
      /** 商品sku组合（精确查询）  */
      product_sku_list: [],
      /** 谷仓商品条码（精确查询） */
      product_barcode: '',
      /** 谷仓商品条码（模糊搜索） */
      product_barcode_like: '',
      /** 谷仓商品条码组合（精确查询）  */
      product_barcode_list: [],
      /** 商品中文名称（模糊搜索） */
      product_title_like: '',
      /** 商品中文名称（精确搜索） */
      product_title: '',
      /** 库存类型  */
      inventory_type: this.$enum.warehouse.InventoryTypeEnum.SELLABLE,
      /** 库存类型对应范围最低值  */
      inventory_type_min: undefined,
      /** 库存类型对应范围最高值  */
      inventory_type_max: undefined,
      /** 排序字段  */
      order_field: '',
      /** 排序顺序[desc: 降序, asc:升序] */
      sort_direction: '',
      /** 批次属性 */
      assign_batch_code: this.$enum.warehouse.BatchAttributeEnum.PRODUCTION_BATCH,
      /** 生产批次集合 */
      production_batch_list: '',
      product_quanlity: this.$enum.product.ProductQualityEnum.GOOD,
      reference_no_list: [],
      reference_no_like: '',
      reference_no: '',
      product_title_en_like: '',
      product_title_en: '',
      page_index: 1,
      page_size: 20,
    };
  }
  /**
 * @description: 检测是否支持商品品质
 * @param {string} val 库存类型
 * @return {*}
 */
  private checkShowProductQuality(val: number): boolean {
    return [
      this.$enum.warehouse.InventoryTypeEnum.SELLABLE,
      this.$enum.warehouse.InventoryTypeEnum.RESERVED,
    ].includes(val);
  }
  /**
   * 获取库存列表
   */
  @loading('loadingStatus')
  private async queryInventoryList(params: TypeBatchInventory.SearchData): Promise<void> {
    this.searchParam = this.$util.deepCopy(params);
    const { data } = await this.$api.warehouse.queryEffectBatchInventory(params);
    const { list, total, sellable_total } = data;
    this.dataList = this.$util.createTableRowKey(list);
    this.total = total;
    this.sellable_total = sellable_total;
    this.$util.setTableColumnSortTip();
  }
  /**
   * 仓库列表
   */
  private async queryWarehouseList(): Promise<void> {
    const { data = [] } = await this.$api.common.queryAllWarehouseList({ is_append_remark: false });
    this.warehouseList = data;
  }
  /**
   * 导出
   */
  private async export(params: TypeBatchInventory.ExportSearchData): Promise<void> {
    const res = await this.$api.warehouse.exportEffectBatchInventory<TypeBase.ExcelDataResult>(params);
    if (res.code === 0) {
      this.$util.exportExcel(res.data);
    }
  }
  /** 查询参数是否是产品相关代码 */
  private isProductCodeField(): boolean {
    return this.codeField === 'product_sku' || this.codeField === 'product_barcode' || this.codeField === 'reference_no';
  }
  /**
   * 获取列表数据
   */
  private getList(): void {
    this.rowSelection.selectedRowKeys = this.selectedIdList = [];
    const skuList = this.docValue.split(',');
    if (skuList.length > 1) {
      this.resetFieldValue();
      if (this.codeField === 'product_sku') {
        this.searchData.product_sku_list = this.docValue.split(',');
      }
      if (this.codeField === 'product_barcode') {
        this.searchData.product_barcode_list = this.docValue.split(',');
      }
      if (this.codeField === 'reference_no') {
        this.searchData.reference_no_list = this.$util.strTurnToArray(this.docValue);
      }
    } else {
      this.updateFieldValue();
    }
    const params = this.$util.deepCopy(this.searchData);
    params.production_batch_list = this.searchData.production_batch_list ? this.$util.strTurnToArray(this.searchData.production_batch_list as string) : [];
    if (this.$util.isEmpty(params.inventory_type_min)) {
      params.inventory_type_min = undefined;
    }
    if (this.$util.isEmpty(params.inventory_type_max)) {
      params.inventory_type_max = undefined;
    }
    this.queryInventoryList(params);
  }
  /**
   * 重置参数
   */
  private resetFieldValue(): void {
    this.searchData.product_title = '';
    this.searchData.product_title_like = '';
    this.searchData.product_sku_list = [];
    this.searchData.product_sku = '';
    this.searchData.product_sku_like = '';
    this.searchData.product_barcode_list = [];
    this.searchData.product_barcode = '';
    this.searchData.product_barcode_like = '';
    this.searchData.reference_no_list = [];
    this.searchData.reference_no_like = '';
    this.searchData.reference_no = '';
    this.searchData.product_title_en_like = '';
    this.searchData.product_title_en = '';
  }
  /**
   * 更新查询条件
   */
  private updateFieldValue(): void {
    this.resetFieldValue();
    if (this.codeField === 'product_sku') {
      if (this.isAccurate) {
        this.searchData.product_sku = this.docValue;
      } else {
        this.searchData.product_sku_like = this.docValue;
      }
    } else if (this.codeField === 'product_barcode') {
      if (this.isAccurate) {
        this.searchData.product_barcode = this.docValue;
      } else {
        this.searchData.product_barcode_like = this.docValue;
      }
    } else if (this.codeField === 'product_title') {
      if (this.isAccurate) {
        this.searchData.product_title = this.docValue;
      } else {
        this.searchData.product_title_like = this.docValue;
      }
    } else if (this.codeField === 'reference_no') {
      if (this.isAccurate) {
        this.searchData.reference_no = this.docValue;
      } else {
        this.searchData.reference_no_like = this.docValue;
      }
    } else if (this.codeField === 'product_title_en') {
      if (this.isAccurate) {
        this.searchData.product_title_en = this.docValue;
      } else {
        this.searchData.product_title_en_like = this.docValue;
      }
    }
  }
  /**
   * 双击批量查询
   */
  private handleDblClick(): void {
    if (this.codeField === 'product_sku' || this.codeField === 'product_barcode' || this.codeField === 'reference_no') {
      const bulkSearchRef = this.$refs.bulkSearchModal as BulkSearchModal;
      bulkSearchRef.modalVisible = true;
      bulkSearchRef.bulkListStr = this.docValue;
    }
  }
  /**
   * 重置页面数据
   */
  private initPage(): void {
    this.searchData.page_index = 1;
    this.selectedIdList = [];
  }
  /**
   * 页码变动
   */
  private handlePageChange(val: number): void {
    this.initPage();
    this.searchData.page_index = val;
    this.getList();
  }
  /**
   * 点击每个tab的回调
   */
  private handleTabChange(key: string): void {
    this.initPage();
    this.getList();
  }
  /**
   * 搜索按钮
   */
  private handleSearch(): void {
    this.initPage();
    this.getList();
  }
  /**
   * 清空
   */
  private handleReset(): void {
    this.docValue = '';
    this.codeField = 'product_sku';
    this.searchData = this.initSearchData();
    this.getList();
  }
  // 导出
  private async handleExportAll(): Promise<void> {
    const params = this.$util.deepCopy(this.searchParam);
    delete params.page_index;
    delete params.page_size;
    this.export(params);
  }
  // 导出
  private async handleExportSelected(): Promise<void> {
    if (!this.selectedIdList.length) {
      this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }
    this.export({
      id_list: this.selectedIdList,
      assign_batch_code: this.searchData.assign_batch_code || undefined
    });
  }
  private handleBulkFeedback(bulkKeywords: string): void {
    this.docValue = bulkKeywords;
  }
  private handleSortChange(pagination: any, filters: any, sorter: any): void {
    const column = this.$util.findItemByKeyValue(this.columns, sorter.column ? sorter.column.name : sorter.columnKey, 'name');
    if (column) {
      this.searchData.order_field = column.name;
      this.columns.forEach((item: TypeBase.TableColumn) => {
        item.defaultSortOrder = undefined;
      });
      column.sortOrderType = this.searchData.sort_direction = column.sortOrderType === 'asc' ? 'desc' : 'asc';
      column.defaultSortOrder = column.sortOrderType === 'asc' ? 'ascend' : 'descend';
      this.searchData.page_index = 1;
      this.getList();
    }
  }
  private handleSearchWayChange(): void {
    this.updateFieldValue();
  }
  private handleSubmitSuccess(): void {
    this.getList();
  }
  /**
   * 查看待出库/预占库存明细
   */
  private handleReservedDetail(record: TypeBatchInventory.ListItem, productQuanlity: number): void {

    reservedDetail({
      parent: this,
      propsData: {
        data: record,
        productQuanlity,
      },
    });
  }
  private created(): void {
    const h = this.$createElement;
    this.columns = [
      {
        title: this.t('商品编码'),
        disabled: true,
        dataIndex: 'product_sku',
        name: 'product_sku',
        scopedSlots: {
          customRender: 'product_sku',
        },
      },
      {
        title: this.t('参考编码'),
        checked: true,
        dataIndex: 'reference_no',
        name: 'reference_no',
        isCopy: true,
      },
      {
        title: this.t('谷仓商品条码'),
        disabled: true,
        dataIndex: 'product_barcode',
        name: 'product_barcode',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('商品中文名称'),
        checked: true,
        name: 'product_title',
        width: 250,
        scopedSlots: {
          customRender: 'product_title',
        },
      },
      {
        title: this.t('商品英文名称'),
        checked: true,
        name: 'product_title_en',
        dataIndex: 'product_title_en',
        width: 250,
        isCopy: true,
      },
      {
        title: this.t('仓库（区域）'),
        dataIndex: 'warehouse_code',
        disabled: true,
        name: 'warehouse_code',
        scopedSlots: {
          customRender: 'warehouse_code',
        },
      },
      {
        title: () => {
          return (
            <div class="p-10">
              <span>{this.t('商品品质')}</span>
              <a-select
                value={this.product_quanlity}
                class="form-item-select"
                show-search
                allowClear
                style="margin-left: 10px;width: 70px;font-size: 12px;"
                onChange={(val: number) => { this.product_quanlity = val; }}
              >
                <a-select-option value={0}>{this.t('全部')}</a-select-option>
                {this.orderProductQualityEnum && this.orderProductQualityEnum.map(item => (
                  <a-select-option value={item.value}>{item.label}</a-select-option>
                ))}
              </a-select>
            </div>
          );
        },
        label: this.t('商品品质'),
        name: 'product_quanlity_text',
        scopedSlots: {
          customRender: 'product_quanlity_text',
        },
        resetCellStyle: true,
        checked: true,
        disabled: true,
      },
      {
        title: () => {
          return <div class='p-10'>
            {/* <a-popover>
              <div slot='content'>{this.t('排序/可售汇总均仅针对商品品质为良品')}</div>
              &nbsp;
              <div class="define-columns-sort-title"> {this.t('可售')}<span style="margin-left: 4px;display: inline-block;color: #999;font-size: 10px;">{this.sellable_total}</span></div>
            </a-popover> */}
            <div class="define-columns-sort-title"> {this.t('可售')}</div>
          </div>;
        },
        label: this.t('可售'),
        disabled: true,
        sorter: true,
        align: 'right',
        filterEmpty: true,
        name: 'sellable_quantity',
        resetCellStyle: true,
        scopedSlots: {
          customRender: 'sellable_quantity',
        },
      },
      {
        title: () => {
          return <div class='p-10'>
            <a-popover>
              <div slot='content'>{this.t('仅支持按良品数量做排序')}</div>
              &nbsp;
              <div class="define-columns-sort-title">{this.t('待出库/预占')}</div>
            </a-popover>
          </div>;
        },
        label: this.t('待出库/预占'),
        name: 'reserved_quantity',
        dataIndex: 'reserved_quantity',
        sorter: true,
        align: 'right',
        filterEmpty: true,
        resetCellStyle: true,
        scopedSlots: {
          customRender: 'reserved_quantity',
        },
      },
      // {
      //   title: this.t('生产日期'),
      //   name: 'creation_date',
      //   dataIndex: 'creation_date',
      //   filterEmpty: true,
      // },
      // {
      //   title: this.t('有效期天数'),
      //   name: 'validity_period_days',
      //   dataIndex: 'validity_period_days',
      //   sorter: true,
      //   filterEmpty: true,
      //   align: 'right',
      // },
      // {
      //   title: this.t('过期日期'),
      //   name: 'expiration_date',
      //   dataIndex: 'expiration_date',
      //   filterEmpty: true,
      // },
      // {
      //   title: () => {
      //     return <div>
      //       {this.t('效期状态')}
      //       <a-popover placement='topRight' arrowPointAtCenter content={this.t('根据有效期管理规则，如果效期状态是临期或过期状态，商品将无法正常出库，如需出库，请联系相关客服处理。')}>
      //         <a-icon class='ml-5' type='question-circle' />
      //       </a-popover>
      //     </div>;
      //   },
      //   name: 'validity_period_status_text',
      //   scopedSlots: {
      //     customRender: 'validity_period_status_text',
      //   },
      //   label: this.t('效期状态'),
      // },
      // {
      //   title: () => {
      //     return <div>
      //       {this.t('剩余天数')}
      //       <a-popover placement='topRight' arrowPointAtCenter content={this.t('距离保质期前剩余的总时长，正数表示商品未过期剩余天数，负数表示商品已过期天数。')}><a-icon class='ml-5' type='question-circle' /></a-popover>
      //     </div>;
      //   },
      //   name: 'remain_day',
      //   dataIndex: 'remain_day',
      //   sorter: true,
      //   align: 'right',
      //   showColumnSetting: true,
      //   filterEmpty: true,
      // },
      {
        title: this.t('生产批次'),
        name: 'production_batch',
        dataIndex: 'production_batch',
        isCopy: true,
        align: 'right',
        showColumnSetting: true,
        filterEmpty: true
      },
    ];
    this.rowSelection = {
      selectedRowKeys: this.selectedIdList,
      onChange: (selectedRowKeys: string[]) => {
        this.rowSelection.selectedRowKeys = this.selectedIdList = selectedRowKeys;
      },
    };
    this.queryWarehouseList();
    this.getList();
  }
}
